// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Question-module--wrapper--3WFYZ","answers":"Question-module--answers--3MPeH"};